import {get} from "lodash"
import BaseService from "./Base"

class SettingsCourseCategoryService extends BaseService {
    async getAllCourseCategories() {
        const response = await this.post("/v1/settings/course-categories/list", {})
        return get(response, "data", [])
    }

    async createCourseCategory(params = {}) {
        const response = await this.post("/v1/settings/course-categories/create", params)
        return get(response, "data.data", {})
    }

    async updateCourseCategory(id, data, params = {}) {
        data.courseCategoryId = id
        const response = await this.post(`/v1/settings/course-categories/edit`, data, params)
        return get(response, "data", {})
    }

    async deleteCourseCategory(courseCategoryIds) {
        const response = await this.post(`/v1/settings/course-categories/delete`, {courseCategoryIds})
        return get(response, [], {})
    }
}

export default SettingsCourseCategoryService
